// extracted by mini-css-extract-plugin
export default {"iconButton":"adh9Yz"};